(ns hai-model.model
  (:require
   hai-model.malli-registry
   [hai-model.model-test-utils :as-alias mtu]
   [humbleai.belt.coll :as belt.coll]
   [humbleai.belt.malli.core :as belt.m]
   [humbleai.belt.malli.transform.translate-keys :as translate-keys]
   [malli.core :as m]
   [malli.registry :as mr]
   [malli.util :as mu])
  #?(:clj (:import clojure.lang.ExceptionInfo)))

(defn register
  [entity-model]
  (let [{entity-name :name} (m/properties entity-model)]
    (mr/set-default-registry!
     (assoc (mr/schemas m/default-registry) entity-name entity-model)))
  entity-model)

(defn models
  [& xforms]
  (into []
        (apply comp
               (keep (comp belt.m/schema second))
               (filter (fn [schema]
                         (some-> (m/properties schema)
                                 :name)))
               xforms)
        (mr/schemas m/default-registry)))

(def User
  (register
   [:map
    {:name :user}
    [:user/uuid {:identity? true} :uuid]
    [:user/email
     {:title "Email"}
     [:vector
      {:gen/min 1
       :gen/max 2}
      :email]]
    [:user/full-name
     {:title "Full Name"
      :optional true}
     :string]
    [:user/signup-pathway
     {:title "Signup Pathway"
      :optional true}
     :keyword]
    [:user/seen-user-login
     {:title "Has logged-in?"
      :optional true}
     :boolean]
    [:user/credits
     {:title "Credits"
      :optional true}
     :int]]))

;; NOTE this is not Organisation
(def Group
  (register
   [:map
    {:name :group}
    [:group/uuid {:identity? true} :uuid]
    [:group/display-name
     {:docstring "The name of the group (org, role, etc.)"}
     :string]
    [:group/description
     {:docstring "A simple description of the group"}
     :string]
    [:group/members
     {:docstring "All the users/resources that are part of the group"}
     [:vector :any]]
    [:group/color
     {:docstring "The color of a group; useful when used as tags for example."}
     :string]
    [:group/owners
     {:docstring "The owners of the group. Could be another group, like team, org, etc. A team could be owned by more than one org."}
     [:vector :any]]
    [:group/owners-scope
     {:docstring "The scope of the group; could be domain or *"}
     [:or
      [:enum "*" "published"]
      :string]]
    [:group/type
     {:docstring "Groups are organisations, teams, resources, etc. Types are not composable, i.e. a thing can only be one type of a group."}
     :keyword]]))

(def GroupType
  [:enum :group.type/organisation])

;; TODO this should be combined with `Group` in a better way
(def Organisation
  (register
   [:map
    {:name :organisation}
    [:group/uuid {:identity? true} :uuid]
    [:group/display-name
     {:title "Display Name"}
     :string]
    [:group/description
     {:optional true
      :title "Description"}
     :string]
    [:group/type
     {:title "Type"}
     [:= :group.type/organisation]]
    [:group/members
     {:optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :user]]
    ;; TODO
    ;; [:group/owners
    ;;  {:ref? true
    ;;   ::mtu/gen? false}
    ;;  [:vector :user]]
    ]))

(def permission-types
  #{:permission.type/read
    :permission.type/update
    :permission.type/delete
    :permission.type/create
    :permission.type/execute
    :permission.type/history
    :permission.type/copy
    :permission.type/download
    :permission.type/sync
    :permission.type/admin

    ;; grant permissions
    :permission.type/grant.read
    :permission.type/grant.update
    :permission.type/grant.delete
    :permission.type/grant.create
    :permission.type/grant.execute
    :permission.type/grant.history
    :permission.type/grant.copy
    :permission.type/grant.download
    :permission.type/grant.sync

    ;; delegate permissions
    :permission.type/delegate.read
    :permission.type/delegate.update
    :permission.type/delegate.delete
    :permission.type/delegate.create
    :permission.type/delegate.execute
    :permission.type/delegate.history
    :permission.type/delegate.copy
    :permission.type/delegate.download
    :permission.type/delegate.sync})

(def all-permissions permission-types)

;; NOTE TODO this is duplicated in `hai.db.datomic.entities.common`
(def visibility-permissions
  #{:permission.type/admin
    :permission.type/read})

(def Permission
  (register (into [:enum {:name :permission}] permission-types)))

(def Config
  (register
   [:map
    {:name :config}
    [:config/uuid
     {:identity? true
      :docstring "Unique identifier for the user"}
     :uuid]
    [:config/type
     {:docstring "Group/user/resource specific config, any third party configuration (not a connection), etc."}
     :keyword]
    [:config/kind
     {:docstring "Kinds are composable - i.e. a thing can be many different kinds."}
     [:vector :keyword]]
    [:config/version
     {:docstring "Incremental version number"
      :our-type :long}
     :int]
    [:config/data
     {:docstring "All the specifics of the config, in EDN"}
     :string]
    [:config/owner
     {:docstring "A reference to the owner of the config - user, group, etc."}
     :any]]))

(def Prompt
  (register
   [:map
    {:name :prompt
     :legacy? true
     :share-type :group.type/share.prompt}
    [:ai-prompt/uuid
     {:docstring "External id for this ai prompt"
      :identity? true
      ::translate-keys/from :uuid}
     :uuid]
    [:ai-prompt/title
     {:docstring "The user defined title of the ai prompt"
      :form.field.label/title "Title"
      ::translate-keys/from :title}
     :string]
    [:ai-prompt/content
     {:docstring "The prompt text"
      :form.field.label/title "Content"
      ::translate-keys/from :content}
     :string]
    [:ai-prompt/updated-at
     {:docstring "Time the prompt was updated"
      ;; :optional true
      :our-type :instant
      ::translate-keys/from :updated-at}
     :time/instant]
    [:ai-prompt/created-at
     {:docstring "Time the prompt was created"
      ;; :optional true
      :our-type :instant
      ::translate-keys/from :created-at}
     :time/instant]
    [:ai-prompt/magic-fill?
     {:docstring "Whether this prompt is available as a magic-fill template option"
      :optional true}
     :boolean]
    [:ai-prompt/version
     {:docstring "Incremental version number"
      :our-type :long
      ::translate-keys/from :version}
     :int]]))

(def Connection
  (register
   [:map
    {:name :connection}
    [:connection/uuid
     {:identity? true}
     :uuid]
    [:connection/user
     {:docstring "The user who owns/created this connection"}
     :user]
    [:connection/type
     {:docstring "Type of connection (i.e. provider)"}
     :keyword]
    [:connection/description
     {:docstring "Human readable representation to be used in UI, should be a short one-liner"}
     :string]
    ;; == Moved to a migration, you can't install a tuple and its dependent attributes at the same time ==
    ;; [:connection/pk :tuple
    ;;  "Tuple attribute with identity uniqueness, ensures that if we get a new
    ;;  connection for the same user and authorization, it replaces the old one."
    ;;  :identity
    ;;  {:db/tupleAttrs [:connection/user
    ;;                   :connection/type
    ;;                   :oauth-conn/authorization]}]
    [:token-conn/token
     {:docstring "For connections types that just use a static token: the token"
      ;; NOTE it's `:sensitive` in schema.clj
      :sensitive true}
     :string]
    #_[:oauth-conn/authorization
       {:docstring "A :oauth.authorization with its associated access-token etc."}
       :ref]
    [:db-conn/url
     {:docstring "For database connections. Might contain password."
      ;; NOTE it's `:sensitive` in schema.clj
      :sensitive true}
     :string]
    [:connection/api-key-invalid?
     {:docstring "True when the backing credential has been detected unusable."}
     :boolean]
    [:connection/api-key-invalidated-at
     {:docstring "When :connection/api-key-invalid? was first set true."}
     :any]
    [:connection/api-key-invalid-reason
     {:docstring "Short tag like :scope-insufficient or :token-revoked."}
     :keyword]]))

(def File
  (register
   [:map
    {:name :file}
    [:ai-file/uuid
     {:docstring "Unique id for this document"
      :identity true}
     :uuid]
    [:ai-file/mime-type
     {:docstring "MIME (media) type of the file"}
     :string]
    [:ai-file/title
     {:docstring "Title/name for the document. Typically the filename."}
     :string]
    [:ai-file/url
     {:docstring "Location of the document for internal use, e.g. a Cloud Storage link accessible via API"}
     :string]
    [:ai-file/plain-text-url
     {:docstring "Location of a version of the document converted to plain text (markdown, csv), amenable to processing by/for LLMs."}
     :string]
    [:ai-file/citation-link
     {:docstring "Location of the document for reference by end users. This is what is shown when 'citations' are on. Can be blank, the same as :ai-file/url, or different from :ai-file/url. Note that this might be overruled by a citation link in doc_chunk metadata, e.g. a link to a specific page."}
     :string]
    [:ai-file/status
     {:docstring "The processing status of the document: :processed, :processing, or :error"}
     :keyword]
    [:ai-file/created-at
     {:docstring "Time the file was created"}
     :time/instant]
    [:ai-file/updated-at
     {:docstring "Time the file was last updated"}
     :time/instant]]))

(def AiFile
  (register
   [:map
    {:name :ai-file}
    [:ai-file/uuid
     {:identity? true
      :docstring "Unique identifier for the file"}
     :uuid]
    [:ai-file/title
     {:docstring "Title/filename of the document"}
     :string]
    [:ai-file/status
     {:docstring "Processing status of the file"}
     [:enum :processing :done :error]]
    [:ai-file/url
     {:docstring "URL to access the file"
      :optional true}
     :string]
    [:ai-file/citation-link
     {:docstring "Link used for citations"
      :optional true}
     :string]
    [:ai-file/mime-type
     {:docstring "MIME type of the file"
      :optional true}
     :string]]))

(def Failure
  (register
   [:map
    {:name :failure}
    [:queue :string]
    [:job-name :string]
    [:job-args {:optional true} :any]
    [:error :string]
    [:error-class {:optional true} :string]
    [:error-message {:optional true} :string]
    [:failed-at {:optional true} :string]
    [:retried-at {:optional true} :string]]))

(def Source
  (register
   [:map
    {:name :source
     :legacy? true}
    [:ai-source/uuid
     {:identity? true}
     :uuid]
    [:ai-source/title
     {:docstring "Title of the source"}
     :string]
    [:ai-source/type
     {:docstring "Type of source"}
     [:enum :file :website :google-drive :sharepoint :onedrive]]
    [:ai-source/link
     {:docstring "Optional link to the source"
      :optional true}
     :string]
    [:ai-source/status
     {:docstring "Processing status of the source"}
     [:enum :processing :done :error]]
    [:ai-source/type-label
     {:docstring "Computed type label to be used by UI"
      :optional true
      ::mtu/gen? false}
     :string]
    [:ai-source/created-at
     {:docstring "Time the source was created"}
     :time/instant]
    [:ai-source/updated-at
     {:docstring "Time the source was last updated"}
     :time/instant]
    [:ai-source/documents
     {:docstring "Documents contained in this source"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector AiFile]]
    [:ai-source/failures
     {:docstring "Job failures related to this source"
      :optional true
      ::mtu/gen? false}
     [:vector Failure]]]))

(def Activity
  (register
   [:map
    {:name :activity}
    [:activity/uuid {:identity? true} :uuid]
    [:activity/url :string]
    [:activity/title {:optional true} :string]
    [:activity/status {:optional true :ref? true} :keyword]
    [:activity/updated-at {:optional true} :time/instant]]))

(def Task
  (register
   [:map
    {:name :task
     :share-type :group.type/share.task}
    [:task/uuid {:identity? true} :uuid]
    [:task/title {:title "Title" :docstring "The user-defined title of the task"} :string]
    [:task/description {:title "Description" :docstring "The description of the task" :optional true} :string]
    [:task/urgency
     {:title "Urgency"
      :docstring "User-chosen urgency: :task.urgency/now, /next, or /later"
      :optional true
      :ref? true}
     :keyword]
    [:task/config {:docstring "Task configuration" :optional true} :map]
    [:task/assigned-to
     {:docstring "The user this task is assigned to"
      :optional true
      :ref? true
      ::mtu/gen? false}
     :any]
    [:task/activities
     {:docstring "URLs linked to this task"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :activity]]
    [:task/completed-at
     {:docstring "When the task was marked complete; absent means open"
      :optional true}
     :time/instant]
    [:task/deadline-at
     {:docstring "The absolute deadline moment; absent means no deadline"
      :optional true}
     :time/instant]
    [:task/deadline-all-day?
     {:docstring "True when the deadline is date-only (floating)"
      :optional true}
     :boolean]
    [:task/deadline-timezone
     {:docstring "IANA zone the deadline was authored in"
      :optional true}
     :string]
    ;; `:any` rather than `[:vector :contact]`/`[:vector :note]`/`[:vector :task]`
    ;; — Task is registered here before Contact and Note, and the tasks link is a
    ;; self-reference, so none of the three link targets can resolve yet. Nothing
    ;; validates or generates these attrs; `->eql`/`->pull` only read `:ref?`.
    [:task/contacts
     {:docstring "Contacts this task references"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :any]]
    [:task/notes
     {:docstring "Notes this task links to"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :any]]
    [:task/tasks
     {:docstring "Other tasks this task links to"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :any]]
    [:task/tags
     {:docstring "Tag display names this task belongs to"
      :optional true
      ::mtu/gen? false}
     [:vector :string]]
    [:task/created-at :time/instant]
    [:task/updated-at :time/instant]]))

(def ContactType
  [:enum :contact.type/individual :contact.type/organisation])

(def Contact
  (register
   [:map
    {:name :contact
     :beta? true}
    [:contact/uuid {:identity? true} :uuid]
    [:contact/full-name
     {:title "Name"
      :docstring "Full UTF-8 name; one field, no first/last split"
      :optional true}
     :string]
    [:contact/humble-user
     {:docstring "Optional ref to the Humble user this contact represents"
      :optional true
      :ref? true
      ::mtu/gen? false}
     :any]
    [:contact/email
     {:title "Emails"
      :docstring "Email addresses for this contact"
      :optional true}
     [:vector :string]]
    [:contact/github-login
     {:title "GitHub"
      :docstring "GitHub username or org login"
      :optional true}
     :string]
    [:contact/linkedin-url
     {:title "LinkedIn"
      :docstring "LinkedIn profile URL"
      :optional true}
     :string]
    [:contact/type
     {:title "Type"
      :docstring "Individual or organisation"
      :optional true}
     ContactType]
    [:contact/members
     {:docstring "Other contacts belonging to this org-typed contact"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :any]]
    [:contact/org-mailing-namespace
     {:title "Mailing domains"
      :docstring "Email domains owned by this org-typed contact"
      :optional true}
     [:vector :string]]
    [:contact/tags
     {:docstring "Tags (:group.type/tag groups) this contact belongs to"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :any]]
    [:contact/created-at {:optional true} :time/instant]
    [:contact/updated-at {:optional true} :time/instant]
    [:contact/auto-filled-from-connection-email
     {:docstring "Email of the calendar connection whose sync auto-created this contact"
      :optional true}
     :string]]))

(def Journal
  (register
   [:map
    {:name :journal
     :share-type :group.type/share.journal}
    [:journal/uuid {:identity? true} :uuid]
    [:journal/enabled-integrations
     {:docstring "Active integration types (e.g. :google-calendar)"
      :optional true}
     [:vector :keyword]]
    [:journal/created-at :time/instant]
    [:journal/updated-at :time/instant]]))

(def Timeline
  (register
   [:map
    {:name :timeline
     :share-type :group.type/share.timeline}
    [:timeline/uuid {:identity? true} :uuid]
    [:timeline/title
     {:docstring "User-visible title"
      :optional true}
     :string]
    [:timeline/filters
     {:docstring "EDN-encoded filter config"
      :optional true}
     :string]
    [:timeline/created-by {:ref? true, :optional true} :user]
    [:timeline/created-at :time/instant]
    [:timeline/updated-at :time/instant]]))

(def TimelineIntegration
  (register
   [:map
    {:name :timeline-integration
     :share-type :group.type/share.timeline-integration}
    [:timeline-integration/uuid {:identity? true} :uuid]
    [:timeline-integration/type
     {:docstring "Type enum (:timeline-integration.type/*)"
      :ref? true}
     :keyword]
    [:timeline-integration/created-by {:ref? true, :optional true} :user]
    [:timeline-integration/created-at :time/instant]
    [:timeline-integration/updated-at :time/instant]]))

(def PrivateLink
  (register
   [:map
    {:name :private-link}
    [:private-link/uuid {:identity? true} :uuid]
    [:private-link/token :string]
    [:private-link/resource {:ref? true} :any]
    [:private-link/created-at :time/instant]
    [:private-link/created-by {:ref? true} :user]
    [:private-link/active? :boolean]]))

(def Assistant
  (register
   [:map
    {:name :assistant
     :legacy? true}
    [:ai-model-config/uuid {:identity? true} :uuid]
    [:ai-model-config/prompts
     {:docstring "The prompts that make up a model config"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :prompt]]
    [:ai-model-config/disabled-prompts
     {:docstring "Disabled model config prompts"
      :optional true
      ::mtu/gen? false}
     [:vector :prompt]]
    [:ai-model-config/sources
     {:docstring "Model config sources"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :source]]
    [:ai-model-config/title
     {:docstring "The user defined name of the ai model config"}
     :string]
    [:ai-model-config/description
     {:docstring "The user defined description of the ai model config"
      :optional true}
     :string]
    [:ai-model-config/specify-sources
     {:docstring "Should sources be specified in the response, i.e. citations"
      :optional true}
     :boolean]
    [:ai-model-config/synced-at
     {:docstring "Indicates when was the last time sources data was synced. If it's not set, it means sources should not be auto-synced."
      :optional true}
     :time/instant]
    [:ai-model-config/updated-at
     {:docstring "Time the model config was updated"}
     :time/instant]
    [:ai-model-config/created-at
     {:docstring "Time the model config was created"}
     :time/instant]
    [:ai-model-config/version
     {:docstring "Incremental version number"}
     :int]
    [:ai-model-config/private-link
     {:docstring "Private link for easy sharing with multiple people"
      ::mtu/gen? false
      :ref? true}
     PrivateLink]
    [:ai-model-config/published?
     {:docstring "Whether this assistant is publicly published"
      ::mtu/gen? false
      :optional true}
     :boolean]]))

(def Note
  (register
   [:map
    {:name :note
     :share-type :group.type/share.note}
    [:note/uuid {:identity? true} :uuid]
    [:note/text
     {:docstring "The text content of the note"
      :optional true}
     :string]
    [:note/source
     {:docstring "Where the note originated (:browser-ext, :web-app, :timeline)"
      :optional true}
     :keyword]
    [:note/scratchpad?
     {:docstring "True when this note is the active scratchpad for a URL"
      :optional true}
     :boolean]
    [:note/tags
     {:docstring "Tag display names this note belongs to"
      :optional true
      ::mtu/gen? false}
     [:vector :string]]
    [:note/activities
     {:docstring "URLs linked to this note"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :activity]]
    [:note/contacts
     {:docstring "Contacts this note references"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :contact]]
    ;; `:any` rather than `[:vector :note]` — Note is still being registered
    ;; here, so a self-reference can't resolve. Nothing validates or generates
    ;; this attr; `->eql`/`->pull` only read the `:ref?` property.
    [:note/notes
     {:docstring "Other notes this note links to"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :any]]
    [:note/tasks
     {:docstring "Tasks this note links to"
      :optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :task]]
    [:note/created-at :time/instant]
    [:note/updated-at :time/instant]]))

(def Tag
  (register
   (mu/update-properties Group assoc
                         :name :tag
                         :beta? true)))

(def MiniApp
  (register
   [:map
    {:name :mini-app}
    [:mini-app/uuid
     {:identity? true
      :docstring "External id for this mini-app"}
     :uuid]
    [:mini-app/title
     {:docstring "Title for the mini-app"}
     :string]
    [:mini-app/description
     {:docstring "Description of the mini-app"
      :optional true}
     :string]
    [:mini-app/connection
     {:docstring "The connection associated with this mini-app"
      :optional true
      :ref? true
      ::mtu/gen? false}
     :connection]
    [:mini-app/connections
     {:optional true
      :ref? true
      ::mtu/gen? false}
     [:vector :connection]] ;; For Metablock mini-apps
    [:mini-app/tool
     {:docstring "Tool associated with the mini-app"}
     :keyword]
    ;; #_
    [:mini-app/config
     {:docstring "Config stored as Transit"}
     :any
     ;; TODO
     ;; :transit
     ]
    [:mini-app/version
     {:docstring "Incremental version number"
      :optional true}
     :int]
    [:mini-app/active?
     {:docstring "Is the mini-app active"}
     :boolean]
    [:mini-app/beta?
     {:docstring "Is the mini-app in beta?"
      :optional true
      ::mtu/gen? false}
     :boolean]]))

(def Solution
  (register
   [:map
    {:name :solution
     :legacy? true}
    [:solution/uuid
     {:docstring "External ID for this solution"
      :identity true}
     :uuid]
    [:solution/title
     :string]
    [:solution/description
     {:optional true}
     :string]
    [:solution/video-link
     {:docstring "video embed link"
      :optional true}
     :string]
    [:solution/slides-link
     {:docstring "slides embed link"
      :optional true}
     :string]
    [:solution/departments
     {:docstring "e.g. Human Resources • Operations • Customer Support"
      :optional true}
     :string]
    [:solution/setup-time
     {:docstring "e.g. 10 minutes"
      :optional true}
     :string]
    [:solution/how-it-works
     {:docstring "This solution combines your CRM with enrichment sources and shows them in a single sidebar."
      :optional true}
     :string]
    [:solution/faq
     {:docstring "Frequently asked questions"
      :optional true}
     :string]
    [:solution/call-to-action
     {:docstring "the text for the call to action button"
      :optional true}
     :string]
    [:solution/action-v1
     {:docstring "ID of assistant template to duplicate"
      :optional true}
     :string]
    [:solution/action-v2
     {:docstring "URL of the flows form to open"
      :optional true}
     :string]
    [:solution/action-v3
     {:docstring "capability, e.g. 'Extract data'"
      :optional true}
     :string]
    [:solution/action-v3-config
     {:docstring "map with :inputs and :outputs"
      :optional true}
     :map]
    [:solution/listed?
     {:docstring "URL of the flows form to open"
      :optional true}
     :boolean]]))

;; TODO swap name with`model` so this is `model` and it is `Model`
(def Model
  [Activity
   Connection
   Note
   Prompt
   Assistant
   MiniApp
   Solution
   Task
   TimelineIntegration
   User
   Organisation
   Source
   Contact])

(def uuid-attr?
  (comp #{"uuid"} name))

(defn entity->uuid-attr
  [entity]
  (some (fn [[attr _]]
          (and (uuid-attr? attr)
               attr))
        entity))

(def id-keys
  #_(->> hai.db.datomic.schema/schema
         (hai.db.datomic/inflate-schema)
         (filter #(= :db.unique/identity (:db/unique %)))
         (map :db/ident)
         sort)
  ;; TODO should be derived from model
  #{:activity/uuid
    :ai-model-config/uuid
    :ai-prompt/uuid
    :ai-source/uuid
    :connection/uuid
    :contact/uuid
    :group/uuid
    :mini-app/uuid
    :note/uuid
    :solution/uuid
    :task/uuid
    :timeline-integration/uuid
    :user/uuid})

;; TODO duplicate of entity->uuid-attr
(defn entity->id-attr
  [entity]
  (when
   (map? entity)
    (or (belt.coll/find-first #(contains? entity %) id-keys)
        (throw (ex-info "Cannot create id-attr" {:entity entity})))))

(defn set-required-keys
  [schema ks]
  (let [required? (set ks)]
    (m/walk
     schema
     (fn [s _ c _]
       (case (m/type s)
         :map
         (m/into-schema
          (m/-parent s)
          (m/properties s)
          (cond->> c
            (m/entries s) (map (fn [[k p s]]
                                 (let [p (if (required? k)
                                           (dissoc p :optional)
                                           (assoc p :optional true))]
                                   [k p s]))))
          (m/options s))

         :multi
         (m/into-schema
          (m/-parent s)
          (m/properties s)
          (cond->> c
            (m/entries s) (map (fn [[k p s]]
                                 [k p (set-required-keys s ks)])))
          (m/options s))

         s)))))

(def Entity
  (register
   [:multi
    {:name :entity
     :error/message "Cannot dispatch on entity (`hai-model.model/Entity`)"
     :dispatch (fn [entity]
                 (try
                   (let [id-attr (entity->id-attr entity)]
                     (if (= :group/uuid id-attr)
                       (:group/type entity)
                       id-attr))
                   (catch #?(:clj ExceptionInfo :cljs :default) _)))}
    [:ai-prompt/uuid :prompt]
    [:mini-app/uuid :mini-app]
    [:ai-model-config/uuid :assistant]
    [:task/uuid :task]
    [:contact/uuid :contact]
    [:timeline-integration/uuid :timeline-integration]
    [:group.type/organisation :organisation]]))

;; NOTE TODO this is duplicated in `hai.db.datomic.entities.common`
(def public "*")
(def published "published")

(def EntityScope
  (register
   [:map
    {:name :entity/scope}
    [:entity/scope
     [:or :domain [:= "*"] [:= "published"]]]]))

(def ContactEmailScope
  "A person share identified only by email — a typed-in address that was never
   picked from the contacts dropdown, so it carries no `:contact/uuid`. The
   platform find-or-creates the recipient by email, and (optional) `full-name`,
   parsed from a `Name <email>` input, names the contact it adds to the sharer's
   book."
  (register
   [:map
    {:name :contact/email-scope}
    [:contact/email [:vector :string]]
    [:contact/full-name {:optional true} :string]]))

(def UserScope
  "An existing share, identified purely by the recipient's `:user/uuid` -- all
   `share/update-to` / `share/delete` need to locate it (the platform resolves
   it via `->ident`, never reading email/name). NOT `model/User`: that requires
   `:user/email` and rejects a present-but-nil `:user/full-name`, both of which a
   shared-with-table row carries. Coercion strips the row down to just the uuid."
  (register
   [:map
    {:name :user-scope}
    [:user/uuid :uuid]]))

(def Scope
  (register
   [:multi
    {:name :scope
     :dispatch (fn [scope]
                 (cond
                   ;; A contact picked from the dropdown (carries its uuid).
                   (:contact/uuid scope) :contact/uuid
                   ;; A typed-in email with no uuid — resolved by email.
                   (:contact/email scope) :contact/email
                   ;; An existing share, as emitted by the shared-with table and
                   ;; fed back into `share/update-to` / `share/delete`.
                   (:user/uuid scope) :user/uuid
                   (:entity/scope scope) :share/scope))}
    [:contact/uuid :contact]
    [:contact/email ContactEmailScope]
    [:user/uuid UserScope]
    [:share/scope EntityScope]]))

;; TODO This is just entity, not model so should maybe be in an entity NS?
(defn ->ident
  [?entity]
  (cond
    (map? ?entity)
    (let [id-attr (entity->id-attr ?entity)]
      [id-attr (get ?entity id-attr)])

    (and (vector? ?entity)
         (= 2 (count ?entity)))
    ?entity

    :else
    (throw (ex-info "Entity map or ref/ident expected" {:?entity ?entity :type (type ?entity)}))))

(defn ->uuid
  [?entity]
  (-> ?entity
      (->ident)
      (second)))

;; TODO wrap this into model
(let [id-attr->group-type* {:ai-prompt/uuid :group.type/share.prompt
                            :connection/uuid :group.type/share.connection
                            :ai-model-config/uuid :group.type/share.ai-model-config
                            :ai-source/uuid :group.type/share.ai-source
                            :mini-app/uuid :group.type/share.mini-app
                            :note/uuid :group.type/share.note
                            :group/uuid :group.type/share.group
                            :task/uuid :group.type/share.task
                            :timeline-integration/uuid :group.type/share.timeline-integration
                            :user/uuid :group.type/share.user
                            :solution/uuid :group.type/share.solution}]
  (defn id-attr->group-type
    [id-attr]
    (or (id-attr->group-type* id-attr)
        (throw (ex-info "Could not find share group-type likely due to it not being listed in `hai-model.model/id-attr->group-type`"
                        {:id-attr id-attr
                         :known-mappings id-attr->group-type*})))))

(defn model->uuid-attr
  [Entity]
  (->> Entity
       (m/children)
       (some (fn [[attr _ _]]
               (and (uuid-attr? attr)
                    attr)))))

(defn ->uuid-attr
  [x]
  (cond
    (belt.m/schema x)
    (model->uuid-attr x)

    (map? x)
    (entity->uuid-attr x)

    :else
    (throw (ex-info "Unsupported input for `->uuid-attr`" {:input x}))))

(comment
  (map ->uuid-attr (legacy-models)))

(def id-attrs
  (into #{}
        (map (fn [model]
               (model->uuid-attr model)))
        Model))

(let [uuid-attr->model (into {}
                             (map (fn [schema]
                                    [(model->uuid-attr schema) schema]))
                             Model)]
  (defn ->model
    [?entity]
    (cond
      (belt.m/schema ?entity)
      ?entity

      (map? ?entity)
      (-> ?entity
          (entity->uuid-attr)
          (uuid-attr->model))

      :else
      (throw (ex-info "Unsupported input for `->model`" {:input ?entity})))))

(defn ->name
  [?entity]
  (-> ?entity ->model m/properties :name))

(defn ->eql
  "Returns only entity attrs, e.g. no ref entity attrs are joined"
  [?entity]
  (let [eql (->> (->model ?entity)
                 (m/children)
                 (mapv
                  (fn [[attr {:keys [optional]} _]]
                    (if optional
                      (list attr {:com.wsscode.pathom3.connect.operation/optional? true})
                      attr))))]
    (conj eql (list :group/_members {:com.wsscode.pathom3.connect.operation/optional? true}))))

(defn- expand-nested
  "Recursively expands a nested-refs vector into pull pattern elements.
  Keywords become `{kw [*]}`, maps recurse into their values."
  [refs]
  (mapv (fn [a]
          (if (map? a)
            (let [[k v] (first a)]
              {k (into '[*] (expand-nested v))})
            {a '[*]}))
        refs))

(defn ->pull
  "Converts a Malli model into a Datomic pull pattern.
  Ref attributes become `{:attr '[*]}`, others become plain keywords.
  Appends `:group/_members` for authorization support.

  Optionally accepts a nested-refs EQL fragment to expand ref attributes
  with sub-pulls, e.g.:
    (->pull Task [{:task/assignees [:user/uuid]}])
  expands :task/assignees to `{:task/assignees [* {:user/uuid [*]}]}`."
  ([?model]
   (->pull ?model nil))
  ([?model nested-refs]
   (let [nested-map (into {} (filter map?) nested-refs)
         eql (->> (->model ?model)
                  (m/children)
                  (mapv
                   (fn [[attr {:keys [ref?]} _]]
                     (if-let [sub-attrs (get nested-map attr)]
                       {attr (into '[*] (expand-nested sub-attrs))}
                       (if ref?
                         {attr '[*]}
                         attr)))))]
     (conj eql :group/_members))))
